<template>
  <div class="b-vehicle-compare-bar-card">
    <div class="b-vehicle-compare-bar-card__image">
      <LazyImage
        v-if="image"
        :image="image"
        class="cursor-pointer"
        @click="onClickButton" />
    </div>
    <div>
      <div class="cursor-pointer" @click="onClickButton">
        <div class="extrabold">
          {{ item.manufacturer }} {{ item.short_model_name }}
        </div>
        <div class="b-vehicle-compare-bar-card__description semibold">
          <span>{{ modelNameComputed }}</span>
        </div>
        <div class="b-vehicle-compare-bar-card__price bold">
          <span>
            {{ item.initial_rental_price }} {{ dictionary.vehiclePriceSuffix }}
          </span>
        </div>
      </div>
      <!-- <button
        type="button"
        class="btn btn-link btn-remove"
        :disabled="recordsLength < 3"
        @click="onClickCard">
        {{ dictionary.removeVehicleButtonText }}
      </button> -->
    </div>
  </div>
</template>

<script>
import * as lib from './../../../lib/lib'
import mixinsLeasingOffers from './../../mixins/leaseitnow-mixins'
import LazyImage from './../common/LazyImage.vue'
import { v4 as uuidv4 } from 'uuid'

export default {
  components: { LazyImage },
  mixins: [mixinsLeasingOffers],
  props: {
    item: {
      required: true,
      type: Object,
    },
    recordsLength: {
      required: false,
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      key: uuidv4(),
    }
  },
  computed: {
    modelNameComputed() {
      if (!this.item) {
        return null
      }
      /* eslint-disable camelcase */
      const { model_name, short_model_name } = this.item
      const modelName = model_name.replace(short_model_name, '')

      return `${modelName} ${this.item.model_key}`
    },

    image() {
      if (!this.item) {
        return null
      }
      const images = this.item.gallery_images
      if (!images.length) {
        return null
      }
      return {
        url: images[0],
        alt: '',
      }
    },
  },
  methods: {
    onClickCard() {
      this.removeRecordFromCompare({ value: this.item.id })
    },
    onClickButton() {
      /* eslint-disable camelcase */
      const { language } = this.$route.params
      const { slug, vehicle_id } = this.item
      this.$router.push({
        name: 'car',
        params: { language, slug, id: vehicle_id },
      })
      lib.scrollToTop()
    },
  },
}
</script>

<style scoped lang="scss">
.b-vehicle-compare-bar-card {
  display: flex;
  align-items: center;
  gap: 8px;
  overflow: hidden;

  img {
    max-height: 40px;
  }

  &__image {
    flex-shrink: 0;
  }

  &__description {
    max-width: fit-content;
    font-size: 12px;
    line-height: 1.1rem;
  }

  .btn-remove {
    color: #c71818;
    margin-top: 4px;
    // font-size: 13px;
    font-weight: 600;

    &:hover,
    &:focus,
    &:active {
      color: #c71818;
    }
  }
}
</style>
